export default __webpack_public_path__ + "static/media/04-1.6b0ca8cc.jpg";